import { axios, handleError } from "../../lib";
import { message } from "antd";

export const altAnnouncements = (data) => ({
  type: "ALT_ANNOUNCEMENTS",
  data,
});

export const getAllAnnouncements =
  (force = false) =>
  async (dispatch, getState) => {
    try {
      if (!force) {
        const { announcements } = getState().dashStats;
        if (announcements && announcements.length > 0) {
          return;
        }
      }
      const response = await axios.get("/admin/announcement/all");
      if (response.status === "success") {
        const announcements = response.data.data || response.data || [];
        dispatch(altAnnouncements(announcements));
      }
    } catch ({ response }) {
      handleError(response);
    }
  };

export const createAnnouncement = (data) => async (dispatch) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      let value = data[key];
      if (key === "is_active") {
        value = value ? 1 : 0;
      }
      formData.append(key, value);
    }
  });

  try {
    const response = await axios.post("/admin/announcement/create", formData);
    if (response.status === "success") {
      await dispatch(getAllAnnouncements(true));
      message.success(response.details, 8);
      return { success: true };
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const updateAnnouncement = (id, data) => async (dispatch) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      let value = data[key];
      if (key === "is_active") {
        value = value ? 1 : 0;
      }
      formData.append(key, value);
    }
  });

  try {
    const response = await axios.post(`/admin/announcement/update/${id}`, formData);
    if (response.status === "success") {
      await dispatch(getAllAnnouncements(true));
      message.success(response.details, 8);
      return { success: true };
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const deleteAnnouncement = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(`/admin/announcement/delete/${id}`);
    if (response.status === "success") {
      await dispatch(getAllAnnouncements(true));
      message.success("Successfully deleted announcement", 8);
      return { success: true };
    }
  } catch ({ response }) {
    handleError(response);
  }
};
